import { LANGUAGE_CODES } from "constants/languageCodes";

function languageCodeToName(languageCode) {
  return LANGUAGE_CODES[languageCode];
}

export default languageCodeToName;
